// @ts-nocheck
// create an admin
export const CREATE_TUTORIAL_REQUEST = "CREATE_TUTORIAL_REQUEST";
export const CREATE_TUTORIAL_SUCCESS = "CREATE_TUTORIAL_SUCCESS";
export const CREATE_TUTORIAL_FAILURE = "CREATE_TUTORIAL_FAILURE";

// fetch demo videos
export const FETCH_DEMO_VIDEOS_REQUEST = "FETCH_DEMO_VIDEOS_REQUEST";
export const FETCH_DEMO_VIDEOS_SUCCESS = "FETCH_DEMO_VIDEOS_SUCCESS";
export const FETCH_DEMO_VIDEOS_FAILURE = "FETCH_DEMO_VIDEOS_FAILURE";

//update demo videos
export const UPDATE_DEMO_VIDEOS_REQUEST = "UPDATE_DEMO_VIDEOS_REQUEST";
export const UPDATE_DEMO_VIDEOS_SUCCESS = "UPDATE_DEMO_VIDEOS_SUCCESS";
export const UPDATE_DEMO_VIDEOS_FAILURE = "UPDATE_DEMO_VIDEOS_FAILURE";

//delete demo video
export const DELETE_DEMO_VIDEOS_REQUEST = "DELETE_DEMO_VIDEOS_REQUEST";
export const DELETE_DEMO_VIDEOS_SUCCESS = "DELETE_DEMO_VIDEOS_SUCCESS";
export const DELETE_DEMO_VIDEOS_FAILURE = "DELETE_DEMO_VIDEOS_FAILURE";